export default {
  "name": "master",
  "api": "https://api.proapp.fi"
}